import { useState, useEffect, useCallback, useRef } from 'react';
import { Form, Container, Col, Row, Button} from 'react-bootstrap';
import OdontogramDisplay from './OdontogramDisplay';
import FloatingCard from './FloatingCard/FloatingCard.jsx';
import EntriesList from './NewEntries/EntriesList.jsx';
import DentistryTextEditor from './DentistryTextEditor.jsx';

import OdontogramService from '../../API/Services/OdontogramService.js';

//  Context
import { useLanguage } from '../../API/Context/LanguageContext';

import { VocabDentistry } from '../../ConfigFiles/multilingual/VocabDentistry';
import './FloatingCard/FloatingCard.jsx'

//  Main plane component.
const DentistryForm = ({}) => {
  //  Consume context
  const { lan } = useLanguage()
  
  //  State to track card visibility.
  const [isCardVisible, setIsCardVisible] = useState(false);
  //  Text editor reference
  const dentistryTextEditorRef = useRef(null);


  const odontogramService = new OdontogramService();

  const handleSearch = async (e) => {
    
    

    try {
      const target_user = localStorage.getItem('patient_username')
      console.log('target_user', target_user)
      const data = await odontogramService.fetchHistory(target_user);
      console.log('dataaaaa', data)
      localStorage.setItem('patient_history_odonto', JSON.stringify(data));
      //  Store patient history.
      //localStorage.setItem('patient_data', JSON.stringify(data));
      //  Concatenate name and lastnames if present.
    } catch (error) {
      console.log('No results found.');
      console.error('Error fetching data:', error);
    }
    openCloseFloatingCard();
  }

  const openCloseFloatingCard = () => {
    setIsCardVisible(prev => !prev);
  }

  // State to store selected quadrants for each object, all false by default.
  const [selectedObjects, setSelectedObjects] = useState([
    //  First quadrant.
    //  Each object represents a tooth.
    {
      obj_id: 'tooth_11',
      //  4 quadrants for tooth.
      quadrants: [false, false, false, false],
      //  Oclusal section (circle at the middle of quadrants).
      oclusal: false,
      //  Root (square on top of quadrant ringed circle).
      root: false,
      //  Tooth as a whole (circle on top of square).
      tooth: false,
    },
    {
      obj_id: 'tooth_12',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_13',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_14',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_15',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_16',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_17',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_18',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    //  Second quadrant.
    {
      obj_id: 'tooth_21',
      
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_22',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_23',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_24',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_25',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_26',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_27',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_28',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    //  Third quadrant.
    {
      obj_id: 'tooth_31',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_32',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_33',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_34',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_35',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_36',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_37',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_38',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    //  Fourth quadrant.
    {
      obj_id: 'tooth_41',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_42',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_43',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_44',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_45',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_46',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_47',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
    {
      obj_id: 'tooth_48',
      quadrants: [false, false, false, false],
      oclusal: false,
      root: false,
      tooth: false,
    },
  ]);

  const handleAddQuadrant = (quadrant_number) => {
    //  List of objects is passed in parts ()
    switch (quadrant_number) {
      case 1:
        return 0
      case 2:
        return 8
      case 3:
        return 16
      case 4:
          return 24
      default:
        return 0
    }
  }


  //  Returns the passed index or reflected depending on the mouth quadrant.
  const normalReflectedIndex = (objectIndex, quadrant_number) => {
    //  Consider original quadrant difference +8 +16 +24
    const ogPositions = handleAddQuadrant(quadrant_number);
    var transformedObjectIndex = objectIndex + ogPositions;
    //  To be modified for quadrants 1 & 3 which numbers are reversed.
    if ([1, 3].includes(quadrant_number)) {
      //  Original index = original lenght - reverse selection lenght + reversed index.
      transformedObjectIndex = ogPositions +  7 - objectIndex
    }
    //  Return either recieved index or reflected when necessary.
    return transformedObjectIndex

  }

  //  Handle selection of quadrants
  const handleSelectQuadrant = (objectIndex, quadrantIndex, quadrant_number) => {
    setSelectedObjects(prevState => prevState.map((object, idx) =>
        idx === normalReflectedIndex(objectIndex, quadrant_number)
          ? {
              ...object,
              quadrants: object.quadrants.map((selected, qIdx) =>
                qIdx === quadrantIndex ? !selected : selected
              ),
            }
          : object
      )
    );
  };
  //  Handle selection of Root
  const handleSelectRoot = (objectIndex, quadrant_number) => {
    setSelectedObjects(prevState =>
      prevState.map((object, idx) =>
        idx === normalReflectedIndex(objectIndex, quadrant_number)
          ? {
              ...object,
              root: !object.root,
            }
          : object
      )
    );
  };
  //  Handle selection of dot (Oclusal).
  const handleSelectOclusal = (objectIndex, quadrant_number) => {
    setSelectedObjects(prevState =>
      prevState.map((object, idx) =>
        idx === normalReflectedIndex(objectIndex, quadrant_number)
          ? {
            ...object,
            oclusal: !object.oclusal,
          }
          : object
        )
      );
  };
  //  Handle selection of whole Tooth.
  const handleSelectTooth = (objectIndex, quadrant_number) => {
    setSelectedObjects(prevState =>
      prevState.map((object, idx) =>
        idx === normalReflectedIndex(objectIndex, quadrant_number)
          ? {
              ...object,
              tooth: !object.tooth,
            }
          : object
      )
    );
  };
  //  Text to be displayed and used for adding comments.
  const [displayText, setDisplayText] = useState('');
  //  Used for determe which tooth the floating card will display.
  const [toothSelected, setToothSelected] = useState(null)
  //  Names of the quadrants.
  const quadrant_names_1 = [VocabDentistry.vestibular[lan], VocabDentistry.mesial[lan], VocabDentistry.palatine[lan], VocabDentistry.distal[lan]]
  const quadrant_names_2 = [VocabDentistry.vestibular[lan], VocabDentistry.distal[lan], VocabDentistry.palatine[lan], VocabDentistry.mesial[lan]]
  const quadrant_names_3 = [VocabDentistry.lingual[lan], VocabDentistry.mesial[lan], VocabDentistry.vestibular[lan], VocabDentistry.distal[lan]]
  const quadrant_names_4 = [VocabDentistry.lingual[lan], VocabDentistry.distal[lan], VocabDentistry.vestibular[lan], VocabDentistry.mesial[lan]]  
  //  Extract selection and represent it in a string.
  useEffect(() => {
    //  Function to build the display string based on selected values
    const object_map = new Map();
    selectedObjects.forEach(obj => {

      var parts_involved = []
      //  For determining correct tooltip names.
      const firstDigit = obj.obj_id.split('_')[1].charAt(0);
      const secondDigit = obj.obj_id.split('_')[1].charAt(1);

      //  Append extracted quadrants to list if any.
      obj.quadrants.forEach((isSelected, index) => {
        if (isSelected) {
          //  TODO this can be optimized, just have no time :)
          switch (firstDigit) {
            case '1':
              parts_involved.push(quadrant_names_1[index]);
              break;
            case '2':
              parts_involved.push(quadrant_names_2[index]);
              break;
            case '3':
              parts_involved.push(quadrant_names_3[index]);
              break;
            case '4':
              parts_involved.push(quadrant_names_4[index]);
              break;
          }
        }
      });

      //  Append oclusal/incisal if selected.
      if (obj.oclusal) {
        parts_involved.push(['1', '2', '3'].includes(secondDigit) ? VocabDentistry.incisal[lan] : VocabDentistry.oclusal[lan]);
      }
      //  Append root if selected.
      if (obj.root) {
        parts_involved.push(VocabDentistry.root[lan]);
      }
      //  Validate if the whole tooth has been selected or if any part has.
      if (obj.tooth || parts_involved.length > 0) {
        object_map.set(obj.obj_id.split('_')[1], parts_involved);
      }
    });

    //  Check if map is empty.
    if (object_map.size === 0) {
      setToothSelected(null);
      setDisplayText("general_note"); // Set to "general_note" if nothing is selected
    } else {
      //  Convert the Map into the desired string format
      const resulting_string = Array.from(object_map).map(([key, values]) => {
        const valuesStr = values.length > 0 ? `(${values.join(", ")})` : "()";
        return `${key}: ${valuesStr}`;
      }).join(", ");

      // Check if only one "father" object is selected (non-empty array)
      const nonEmptyKeys = Array.from(object_map).filter(([key, values]) => values.length > 0);
      // Update the justOneSelected state
      if (nonEmptyKeys.length === 1) {
        setToothSelected(nonEmptyKeys[0][0]);
      } else {
        setToothSelected(null);
      }

      //  Make string available to other components.
      setDisplayText(resulting_string);
    }
  }, [selectedObjects]);


  
  const [text, setText] = useState('');
  // Handle text changes from the text editor
  const handleTextChange = useCallback((newText) => {
    setText(newText);
  }, []);

  //  Dentistry editor is automatically cleared after including the comment into the list.
  const clearDentistryTextEditor = () => {
    if (dentistryTextEditorRef.current) {
      dentistryTextEditorRef.current.clearEditor();
    }
  };

  const onSaveNotes = async (notesToSave) => {
    const patient_username = localStorage.getItem('patient_username')
    odontogramService.createEntry(patient_username, notesToSave.teeth_notes, notesToSave.general_note)
    .then(response => {
      console.log("Appointment created successfully:", response);
    })
    .catch(error => {
      console.error("Failed to create appointment:", error);
    });
  }

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <Button
            block
              variant="info"
              onClick={handleSearch}
            >
              {isCardVisible ? '-' : '+'}
            </Button>
            {isCardVisible && 
            <FloatingCard
            show={isCardVisible}
            onClose={openCloseFloatingCard}
            lan={lan}
            />
            }
          </Col>
        </Row>
        <Row>
          <Col
          xs={12}
          >
            <OdontogramDisplay
            lan={lan}
            selectedObjects={selectedObjects}
            parentHandleSelectQuadrant={handleSelectQuadrant}
            parentHandleSelectRoot={handleSelectRoot}
            parentHandleSelectOclusal={handleSelectOclusal}
            parentHandleSelectTooth={handleSelectTooth}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Form.Group controlId="selectedTooth" className="mb-1">
              <Form.Label>{VocabDentistry.selection[lan]}:</Form.Label>
              <Form.Control
                type="text"
                placeholder={VocabDentistry.selection_placeholder[lan]}
                value={displayText}
                disabled
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={5}>
            <DentistryTextEditor
            ref={dentistryTextEditorRef}
            placeholder={VocabDentistry.notes_placeholder[lan]}
            onTextChange={handleTextChange}
            />
          </Col>
          <Col xs={7}>
            <EntriesList
            upcomingTitle={displayText} 
            upcomingNote={text}
            onListNotes={clearDentistryTextEditor}
            onSaveNotes={onSaveNotes}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DentistryForm;
